import React, {Component} from 'react';
import Relay from 'react-relay';
// import initRelayNetworking from '../../helper/network.js'
import NavbarLogin from '../../components/navbarLogin'
// import AddConversationMutation from '../../mutations/AddConversationMutation';

export default class Login extends Component{

  constructor(props)
  {
    super(props);

    this.state={em:false,pwd:false,success:false,error:false,danger:false};
    this.validateEmail=this.validateEmail.bind(this);
    this.pwdCheck=this.pwdCheck.bind(this);
    this.sendData=this.sendData.bind(this);
  }

  validateEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.setState({em:re.test(this.refs.email.value.trim())});
  }

  pwdCheck()
  {
    var new_pd=this.refs.pwrd.value.trim();
    var old_pd=this.refs.old_pwrd.value.trim();
    if(new_pd==old_pd) {
      this.setState({error:false});
      this.setState({pwd:true});
    }
    else {
      this.setState({error:true,pwd:false});
    }
  }

  sendData()
  {
    if(this.state.pwd == true){
    var userId=window.location.href.split("?")[1].split("=")[1];
    var params = JSON.stringify({
      "password": this.refs.pwrd.value
    });
    var url = 'http://surveymate-io.herokuapp.com/api/users/'+userId;
    var responseCode;
    var responseText;
    var self = this;
    // console.log(params);
    var response = fetch(url, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: params
    }).then(function (response) {
        responseCode = response.status;
        return response.text();
    }).then(function (result) {
        // var jsonData = JSON.parse(result);
        if (responseCode == 200) {
          self.setState({success:true});
          self.setState({danger:false});
        }
        else {
          self.setState({danger:true});
          self.setState({success:false});
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
  }
  }

  render ()
  {

    var  eclass,btn1class,btn2class;
    var st={
        pro:{
        width:"100%",
        backgroundColor:"#1a84eb",
      },
      pro_h:{
        height:"9px",
        borderRadius: "2px",
      },

      in:{
        height: "50px",
        borderRadius: "5px",
      },
      small_:{
        opacity: 0.5,
         fontSize: "12px",
         letterSpacing: "0.3px",
         color: "#000000",
      },
      bttn_attri:{
        height:"44px",
        backgroundColor:"#1a84eb",
        border:"none"

      },

      prev_attri:{
        textDecoration:"none",
        color:"#000000",
        border:"none"
      },
      or_:{
        paddingTop:"10px",
      }
    }

    if(this.state.em)
    {
      eclass="form-group has-success"
    }
    else {
      eclass="form-group has-error"
    }
    if(this.state.pwd)
    {
      btn1class="btn btn-info btn-lg pull-left col-md-5";
      btn2class="btn btn-info  btn-lg pull-right col-md-5";
      st.bttn_attri.backgroundColor="#1a84eb";
    }
    else {
      btn1class="btn btn-info btn-lg pull-left col-md-5 disabled";
      btn2class="btn btn-info  btn-lg pull-right col-md-5 disabled";
      st.bttn_attri.backgroundColor="#d1d1d1";
    }
    var danger=""
    if(this.state.danger){
      danger=<div className="text-danger">Some error. Try again.</div>
    }
    var error="";
    if(this.state.error)
    {
      error=<div className="text-danger">Both passwords must be same</div>
    }
    var success="";
    if(this.state.success)
    {
      success=<div><span className="text-success">Password Successfully reset.</span><a href="/#/login"> Login Now</a></div>;
    }
      return (
        <div>
        <div>
          <NavbarLogin />
        </div>
        <div>
          <h1 className="text-center">Change Password</h1>
        </div>

        <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <form role="form">
            <div className={eclass} >
              <label htmlFor="usr">NEW PASSWORD</label>
              <input type="password" className="form-control" id="usr" style={st.in} ref="old_pwrd"/>
            </div>
            <div className="form-group">
              <label htmlFor="sel1">CONFIRM PASSWORD</label>
              <input type="password" className="form-control" id="usr" style={st.in} onChange={this.pwdCheck} ref="pwrd"/>
            </div>
            {error}
            {success}
            {danger}
          </form>
        </div>
        
        <div className="col-md-2"></div>
        </div>
        <br />
        <br />
        <br />

        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
              <div className="col-md-7">
                <div className="row">
                  <a className={btn2class} style={st.bttn_attri} onClick={this.sendData}><small>Change Password</small>
                    <small><span className="glyphicon glyphicon-menu-right glyphicon"></span></small>
                  </a>
                  </div>
              </div>
            </div>
          <div className= "col-md-2"></div>
        </div>


        </div>
      );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/reset/index.js
 **/